import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plataforma',
  templateUrl: './plataforma.component.html',
  styleUrls: ['./plataforma.component.scss']
})

export class PlataformaComponent implements OnInit  {
  data: any;
  
  constructor(
    private translate: TranslateService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('PRINCIPAL.PAGES.PLATAFORMA').subscribe(
      res => {
        this.data = res;
      });
  }
  
  onActivate(event) {
    window.scroll(0, 0);
  }
}
